module.exports = __webpack_public_path__ + "img/cetae-logo-inverso.2ff3b4bf.png";